/**
 * Created by Ricardo Sansores on 2017-06-24.
 * "Customer" service
 *
 * This consumes Customer REST Api
 *
 *
 */
import request from './request';
import { serializeParams } from '../common/helpers';

export const get = (url = '', params = {}) => {
  return request().get(`${url}${serializeParams(params)}`)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
};

export const post = (url = '', params = {}) => {
  return request().post(url, params)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
};

export const patch = (url = '', params = {}) => {
    return request().patch(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const put = (url = '', params = {}) => {
  return request().put(url, params)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error;
    });
};

export const Delete = (url = '', params = {}) => {
  return request().delete(url, params)
    .then(response => {
      //return { reponse: response.data, color: '#04B404'};
      return { message: "El Cliente fue eliminado correctamente", color: '#04B404' };
    })
    .catch(error => {
      return { message: error.response.data.message, color: '#ce3b3b' };
    });
};

export const getCustomers = (params = {}) => {
    return request()
        .get(`customers?projection=denormalizedCustomer&sort=name`)
        .then(response => response.data._embedded)
        .catch(() => []);
};

var testData = {
  "_embedded": {
    "customers": [{
      "name": "Smart Software Factory SA de CV",
      "taxId": "SSF0945443M4",
      "phone1": "3314247302",
      "phone2": null,
      "email1": "rogelio@ssf.mx",
      "email2": null,
      "email3": null,
      "address": {
        "street": "Av. Castillo de Chapultepec",
        "externalNumber": "2883",
        "internalNumber": null,
        "zipCode": "44066",
        "colony": "El Fortin",
        "city": "Zapopan",
        "state": "Jalisco",
        "country": 1,
        "municipality": "Zapopan"
      },
      "_links": {
        "self": {
          "href": "http://192.168.1.36:8080/afs/v1/customers/dd4de6b0-1dec-4c35-a123-b84674d43b4e"
        },
        "customer": {
          "href": "http://192.168.1.36:8080/afs/v1/customers/dd4de6b0-1dec-4c35-a123-b84674d43b4e"
        },
        "executiveUser": {
          "href": "http://192.168.1.36:8080/afs/v1/customers/dd4de6b0-1dec-4c35-a123-b84674d43b4e/executiveUser"
        }
      }
    }]
  },
  "_links": {
    "self": {
      "href": "http://192.168.1.36:8080/afs/v1/customers{?page,size,sort}",
      "templated": true
    },
    "profile": {
      "href": "http://192.168.1.36:8080/afs/v1/profile/customers"
    },
    "search": {
      "href": "http://192.168.1.36:8080/afs/v1/customers/search"
    },
    "saveCustomerWithAddress": {
      "href": "http://192.168.1.36:8080/afs/v1/customers/full"
    }
  },
  "page": {
    "size": 20,
    "totalElements": 1,
    "totalPages": 1,
    "number": 0
  }
}



// WEBPACK FOOTER //
// ./services/customers.js